export default "__VITE_ASSET__CUIs6Kcf__"